const module = { name: 'shared/movies/movieState.worker', exports: {} }; const exports = module.exports;



import { Fandango as Fandango } from 'require-core';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as link } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { Fandango_dateUtil as Fandango_dateUtil_formatDateObject_whatsThisDateToMe } from 'require-global';

const { formatDateObject, whatsThisDateToMe } = Fandango_dateUtil_formatDateObject_whatsThisDateToMe;


import { Fandango_queryUtil as Fandango_queryUtil_getParam } from 'require-core';

const { getParam } = Fandango_queryUtil_getParam;


import { Fandango_util as Fandango_util_formatDate_toDate } from 'require-global';

const { formatDate, toDate } = Fandango_util_formatDate_toDate;


import { default as shared_utils_objUtils_clone_pick } from 'swug-fdRequire-call:shared/utils/objUtils';

const { clone, pick } = shared_utils_objUtils_clone_pick;


import { global_consts as global_consts_QueryParams } from 'require-core';

const { QueryParams } = global_consts_QueryParams;


import { global_utils_functionUtils as global_utils_functionUtils_noop } from 'require-global';

const { noop } = global_utils_functionUtils_noop;


const States = Object.freeze({
    START: '',
    CALENDAR_FETCH: 'calendar:fetch',
    CALENDAR_DONE: 'calendar:done',
    SHOWTIMES_FETCH: 'showtimes:fetch',
    SHOWTIMES_DONE: 'showtimes:done',
    SET_STATE: 'setMovieState',
    SET_ATTRIBS: 'setMovieAttribs',
    SET_ADOBE_LAUNCH: 'setAdobeLaunch',
    THEATER_FETCH: 'theater:fetch',
    FAIL: 'done:fail',
    DONE: 'done:success',
})


const StatusTypes = Object.freeze({
    FETCHING: 'fetching',
    SUCCESS: 'success',
    ERROR: 'error',
})


const DefaultContext = Object.freeze({
    calendar: {},
    error: null,
    adobeLaunch: {},
    movie: {},
    movieAttribs: {},
    movieState: {},
    request: {},
    showtimes: {},
    startShowtimes: {},
    state: null,
})
function readPageContext(Fandango) {
    const { pageDetails } = Fandango;
    return {
        partnerRestrictedTicketing: pageDetails.partnerRestrictedTicketing,
    };
}


let instanceContext
function updateMovieAttribs(movieAttribs, context) {
    const { movie: { isReleaseInFuture, releaseDate, showStreaming, showStreamingPresale }, showtimes: { hasShowtimes }, startShowtimes: { theaterShowtimes } } = context;
    const { showTicketingPresale } = movieAttribs;
    const restricted = theaterShowtimes?.theaters[0]?.variants[0]?.amenityGroups[0]?.showtimes[0].type === 'restricted';
    Object.assign(movieAttribs, {
        hideDateFormatSelection: !showTicketingPresale && !showStreaming && !hasShowtimes,
        showFanalert: (!showTicketingPresale && !hasShowtimes && (isReleaseInFuture || !releaseDate)) || restricted,
        showStreaming: Boolean(showStreaming),
        showStreamingPresale: Boolean(showStreamingPresale),
    });
}
function updateAdobeLaunch(adobeLaunch, context) {
    const { movieAttribs: { showStreaming, showFanalert }, movieState: { isPreRelease, isTicketingWindow, isNotTicketingWindow }, } = context;
    const trackingState = [isPreRelease && 'isPreRelease', isNotTicketingWindow && 'isNotTicketingWindow', isTicketingWindow && 'isTicketingWindow']
        .filter(Boolean)
        .join(',');
    const trackingAttribs = [showStreaming && 'showStreaming', showFanalert && 'showFanalert']
        .filter(Boolean)
        .join(',');
    Object.assign(adobeLaunch, {
        trackingAttribs,
        trackingState,
    });
}
function updateMovieState(movieState, context) {
    const { movie: { releaseDate, isReleaseInFuture }, showtimes: { hasShowtimes }, calendar: { selectedDate } } = context;
    const { inPast } = whatsThisDateToMe(releaseDate);
    const isPreRelease = Boolean(isReleaseInFuture && !hasShowtimes);
    const today = formatDate(new Date());
    Object.assign(movieState, {
        isPreRelease,
        isPreSaleDesktopLegacy: selectedDate && today !== selectedDate,
        isTicketingWindow: Boolean(!isPreRelease && (releaseDate && hasShowtimes)),
        isNotTicketingWindow: Boolean(inPast && !hasShowtimes),
    });
}
function onFetchShowtimesSuccess(data, context, next) {
    if (!data || data.error) {
        debugLog.warn(`${module.name} showtimes error: ${data && data.error || 'unknown error'}`);
        return next(Object.assign(context, {
            state: States.SHOWTIMES_DONE,
            showtimes: { hasShowtimes: false, theaterShowtimes: { theaters: [] } },
        }));
    }
    next(Object.assign(context, {
        state: States.SHOWTIMES_DONE,
        [context.movieAttribs.showTicketingPresale ? 'startShowtimes' : 'showtimes']: data,
    }));
}
function onFetchShowtimesFail(data, context, next) {
    debugLog.warn(`${module.name} showtimes fetch failed`, data);
    next(Object.assign(context, {
        state: States.SHOWTIMES_DONE,
        showtimes: { hasShowtimes: false, theaterShowtimes: { theaters: [] } },
    }));
}
function fetchShowtimes(context, next) {
    const theaterParam = getParam(QueryParams.THEATER);
    const { movie: { id }, movieAttribs: { showTicketingPresale, startDate }, request: { chainCode, date, isDesktop, isDesktopMOP, location, page }, theaterId, } = context;
    Object.assign(context, { error: null });
    if (theaterParam && !theaterId) {
        return next(Object.assign(context, {
            state: States.THEATER_FETCH,
            theaterId: theaterParam,
        }));
    }
    if (!location || !location.params) {
        return next(Object.assign(context, {
            state: States.SHOWTIMES_DONE,
            error: 'getGroupings no location/params',
        }));
    }
    const params = {
        isdesktop: isDesktop,
        ...location,
    };
    Object.assign(params, {
        isDesktopMOP: Boolean(isDesktopMOP)
    });
    if (page) {
        Object.assign(params, {
            page
        });
    }
    function makeShowtimesCall() {
        const { partnerRestrictedTicketing } = readPageContext(Fandango);
        const url = link.napiTheaterShowtimeGroupings({
            id,
            startDate: (showTicketingPresale ? startDate : date) || formatDate(new Date())
        }, params);
        xhr.ajax({
            method: 'GET',
            url,
            data: {
                partnerRestrictedTicketing,
            },
        })
            .done(data => onFetchShowtimesSuccess(data, context, next))
            .fail(data => onFetchShowtimesFail(data, context, next));
    }
    if (!chainCode) {
        return makeShowtimesCall(params);
    }
    xhr.ajax({
        method: 'GET',
        url: link.napiChainCodeValidation({ chainCode })
    })
        .done((results) => {
        if (results && results.isValidChainCode) {
            params.chainCode = chainCode;
        }
        else {
            debugLog.warn(`${module.name} - invalid Chain Code "${chainCode}"`);
        }
        makeShowtimesCall(params);
    })
        .fail(err => onFetchShowtimesFail({ err, msg: `chain code validation failure (Chain Code "${chainCode}")` }, context, next));
}
function onFetchPriorityTheaterSuccess(data, context, next) {
    const { movie: { id } } = context;
    const theater = data.viewModel;
    const movieShowtimes = theater?.movies?.find(movie => movie.id === id);
    if (data.error || !theater || !movieShowtimes) {
        return next(Object.assign(context, {
            state: States.SHOWTIMES_FETCH,
            error: data || 'priority cinema has no showtimes for this film',
        }));
    }
    next(Object.assign(context, {
        state: States.SHOWTIMES_FETCH,
        priorityTheater: { ...theater.theater.details, showtimes: movieShowtimes }
    }));
}
function onFetchPriorityTheaterFail(data, context, next) {
    next(Object.assign(context, {
        state: States.SHOWTIMES_FETCH,
        error: data || 'fetch priority theater API fail',
    }));
}
function fetchPriorityTheater(context, next) {
    const { theaterId, request: { date, isDesktop } } = context;
    Object.assign(context, { error: null });
    const theaterParams = {
        startDate: date || formatDate(new Date()),
        isdesktop: isDesktop
    };
    xhr.ajax({
        method: 'GET',
        url: link.napiTheaterMovieShowtimes({
            id: theaterId,
        }),
        data: theaterParams
    })
        .done(data => onFetchPriorityTheaterSuccess(data, context, next))
        .fail(data => onFetchPriorityTheaterFail(data, context, next));
}
function onFetchCalendarSuccess(data, context, next) {
    const { request: { date, useInitialRequestDate }, movieAttribs, movieState } = context;
    Object.assign(movieAttribs, {
        showTicketingPresale: false,
    });
    if (data.hasCalendar) {
        let startDate;
        try {
            startDate = data.movieCalendar.calendar[0].full;
        }
        catch (e) {
            startDate = null;
        }
        if (startDate) {
            const { inFuture, isTomorrow } = whatsThisDateToMe(startDate, date);
            if (date && !useInitialRequestDate) {
                Object.assign(context.request, {
                    initialRequestDate: formatDateObject(toDate(date)),
                });
            }
            Object.assign(movieState, {
                isOpensTomorrow: isTomorrow,
            });
            Object.assign(movieAttribs, {
                showTicketingPresale: inFuture,
                startDate
            });
            if (!date && inFuture) {
                return update({ date: startDate, useInitialRequestDate: true });
            }
        }
    }
    next(Object.assign(context, {
        state: States.CALENDAR_DONE,
        calendar: data,
    }));
}
function onFetchCalendarFail(data, context, next) {
    next(Object.assign(context, {
        state: States.CALENDAR_DONE,
        error: data || 'calendar fetch failed',
    }));
}
function fetchCalendar(context, next) {
    const { movie: { id, sluggedTitle }, request: { date, location } } = context;
    const params = date ? { date } : {};
    const url = link.napiMovieCalendar({ title: sluggedTitle, id }, params);
    Object.assign(context, { error: null });
    xhr.ajax({
        method: 'GET',
        url,
        data: location && location.params || {}
    })
        .done(data => onFetchCalendarSuccess(data, context, next))
        .fail(data => onFetchCalendarFail(data, context, next));
}
function nextStep(context) {
    const { state = States.START } = context;
    switch (state) {
        case States.START: {
            instanceContext = Object.assign(clone(DefaultContext), pick(context, 'movie', 'request', 'onCalendarChange', 'onShowtimesChange', 'onDone'), { state: States.CALENDAR_FETCH });
            if (instanceContext.request.bypassCalendarFetch) {
                instanceContext.state = States.SHOWTIMES_FETCH;
            }
            nextStep(instanceContext);
            break;
        }
        case States.CALENDAR_FETCH: {
            const { onCalendarChange } = context;
            onCalendarChange(StatusTypes.FETCHING, null, null, context);
            fetchCalendar(context, nextStep);
            break;
        }
        case States.CALENDAR_DONE: {
            const { onCalendarChange, error } = context;
            const status = error ? StatusTypes.ERROR : StatusTypes.SUCCESS;
            onCalendarChange(status, error, pick(context, 'calendar', 'request', 'movie'), context);
            nextStep(Object.assign(context, { state: error ? States.FAIL : States.SHOWTIMES_FETCH }));
            break;
        }
        case States.SHOWTIMES_FETCH: {
            const { onShowtimesChange } = context;
            onShowtimesChange(StatusTypes.FETCHING, null, null, context);
            fetchShowtimes(context, nextStep);
            break;
        }
        case States.SHOWTIMES_DONE: {
            const { onShowtimesChange, error, priorityTheater, showtimes } = context;
            const status = error ? StatusTypes.ERROR : StatusTypes.SUCCESS;
            Object.assign(context, {
                state: error ? States.FAIL : States.SET_STATE
            });
            if (priorityTheater && showtimes.theaterShowtimes) {
                showtimes.theaterShowtimes.theaters = showtimes.theaterShowtimes.theaters.filter(theater => theater.id !== priorityTheater.formattedID);
                showtimes.theaterShowtimes.theaters.unshift({
                    ...priorityTheater,
                    variants: priorityTheater.showtimes.variants
                });
            }
            onShowtimesChange(status, error, pick(context, 'showtimes', 'request', 'movie'), context);
            nextStep(context);
            break;
        }
        case States.THEATER_FETCH: {
            fetchPriorityTheater(context, nextStep);
            break;
        }
        case States.SET_STATE: {
            updateMovieState(context.movieState, context);
            nextStep(Object.assign(context, {
                state: States.SET_ATTRIBS,
            }));
            break;
        }
        case States.SET_ATTRIBS: {
            updateMovieAttribs(context.movieAttribs, context);
            nextStep(Object.assign(context, {
                state: States.SET_ADOBE_LAUNCH,
            }));
            break;
        }
        case States.SET_ADOBE_LAUNCH: {
            updateAdobeLaunch(context.adobeLaunch, context);
            nextStep(Object.assign(context, {
                state: States.DONE,
            }));
            break;
        }
        case States.DONE: {
            const { onDone } = context;
            onDone(StatusTypes.SUCCESS, null, pick(context, 'adobeLaunch', 'calendar', 'movie', 'showtimes', 'movieState', 'movieAttribs'), context);
            break;
        }
        default: {
            const { onDone } = context;
            const error = state === States.FAIL ? 'FAIL' : `unrecognized state "${state}"`;
            debugLog.error(`${module.name}.completed unsuccessfully (${error})`);
            onDone(StatusTypes.ERROR, error, pick(context, 'adobeLaunch', 'calendar', 'movie', 'showtimes', 'movieState', 'movieAttribs'), context);
        }
    }
}
function run(options) {
    options = noop(options, 'onCalendarChange', 'onShowtimesChange', 'onDone');
    nextStep(Object.assign(options, {
        movie: options.movie || {},
        request: options.request || {},
    }));
}
function update(options) {
    const { bypassCalendarFetch, chainCode, date, location, page, allowSameDateCalendarUpdate, useInitialRequestDate = false, } = options || {};
    let requestUpdates;
    if (date || allowSameDateCalendarUpdate) {
        if (date === instanceContext.request.date && !instanceContext.movieAttribs.showTicketingPresale && !allowSameDateCalendarUpdate) {
            debugLog.warn(`${module.name}.update date has not changed ${date}`);
        }
        else {
            requestUpdates = Object.assign(requestUpdates || {}, {
                date,
                initialRequestDate: formatDateObject(toDate()),
                useInitialRequestDate,
            });
        }
    }
    if (location) {
        requestUpdates = Object.assign(requestUpdates || {}, { location });
    }
    if (page) {
        requestUpdates = Object.assign(requestUpdates || {}, { page });
    }
    if (chainCode !== undefined) {
        requestUpdates = Object.assign(requestUpdates || {}, { chainCode });
    }
    if (requestUpdates) {
        if (bypassCalendarFetch) {
            Object.assign(requestUpdates, { bypassCalendarFetch });
        }
        Object.assign(instanceContext.request, requestUpdates);
        nextStep(Object.assign(instanceContext, {
            state: States.START,
        }));
    }
}
module.exports = {
    __testable__: {
        formatDate,
        DefaultContext,
        nextStep,
        States,
        updateMovieAttribs,
        updateMovieState,
        updateAdobeLaunch,
    },
    StatusTypes,
    run,
    update,
};
export default module.exports;